import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { X } from "lucide-react"
import { useTranslation } from "react-i18next"

type Props = {
  name: string
  onRemove?: () => void
  className?: string
}

export function TagBadge({ name, onRemove, className }: Props) {
  const { t } = useTranslation()

  return (
    <Badge
      variant="outline"
      className={cn(
        "h-8 max-w-full shadow-none",
        onRemove ? "pl-3 pr-1.5" : "px-3 text-muted-foreground",
        className,
      )}
    >
      <span className="truncate">{name}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={t("customers.tags.remove", { name })}
          className="rounded-sm p-0.5 text-muted-foreground hover:bg-accent hover:text-foreground"
        >
          <X className="size-3.5" />
        </button>
      )}
    </Badge>
  )
}
